(function () {
  'use strict';

  angular.module('app').component('vehicleDetail', vehicleDetail());

  function vehicleDetail() {
    return {
      bindings: {
        item: '=',
        hideTopControls: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: VehicleDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/vehicles/vehicle-detail/vehicle-detail.component.html',
    };
  }

  VehicleDetailComponent.$inject = [
    'UtilService',
    'VehicleService',
    '$cacheFactory',

    // Angular downgraded service
    'occupancyTypeService',
    'occupancyTypeModalService',
  ];

  function VehicleDetailComponent(
    UtilService,
    VehicleService,
    $cacheFactory,

    // Angular downgraded service
    occupancyTypeService,
    occupancyTypeModalService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // private properties
    // -----------------------
    let cropedImage = { file: null };

    // Navigation
    vm.vehicles = [];
    vm.loadingVehicles = false;
    vm.vehicleSelected = null;
    vm.loadingOtherVehicle = false;
    vm.getVehicles = getVehicles;
    vm.selectVehicle = selectVehicle;
    vm.goToOtherVehicle = goToOtherVehicle;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.flashMessage = vm.UtilService._displayFlashMessage();
        setItemOptions(vm.item);
        getVehicles();
      } else {
        // New
        vm.createMode = true;

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      getOccupancyTypes();
    };

    // public methods
    // -----------------------

    vm.openOccupancyTypesModal = function () {
      // const successCallback = () => {
      //   getOccupancyTypes();
      // };

      occupancyTypeModalService.openOccupancyTypesModal(getOccupancyTypes);
    };

    vm.openTranslations = function () {
      VehicleService.openVehicleTranslations(vm.item, vm.additionalLanguages);
    };

    vm.openLogo = function () {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          VehicleService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      VehicleService.openLogo(vm.item, logoSaved);
    };

    // Create/Update
    vm.saveVehicle = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      vm.sendingForm = true;
      VehicleService.saveVehicle(vm.item, vm.defaultLanguage, cropedImage).then(
        function (response) {
          let data = response.data;

          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: data });
          } else {
            vm.flashMessage = vm.UtilService._clearFlashMessage();

            //vm.itemName = data.name;

            setItemOptions(data);

            vm.UtilService.scrollToTop();
          }

          vm.sendingForm = false;
        },
        function (response) {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

          vm.formErrors = true;
          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        }
      );
    };

    vm.cancel = function () {
      vm.onCanceledItem({ item: vm.item });
    };

    // private methods
    // -----------------------
    function setItemOptions(item) {
      vm.editMode = true;

      vm.itemName = item.name;

      vm.labelAddLogo = vm.item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
    }

    function getOccupancyTypes() {
      let params = {
        get: 'active',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingOcupancyTypes = true;
      occupancyTypeService.getOccupancyTypes(params).subscribe((response) => {
        vm.occupancyTypes = response;
      });
    }

    function getVehicles() {
      if (VehicleService.hasVehiclesCache()) {
        const cachedData = VehicleService.getVehiclesCache();
        vm.vehicles = cachedData;
        setVehicleNavigation();
        return;
      }

      const params = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
        per_page: 10000,
        skip_check_role: true,
      };

      vm.loadingVehicles = true;
      VehicleService.getVehicles(params).then(
        function (data) {
          const vehiclesData = data.items || [];

          vm.vehicles = [];
          vehiclesData.forEach((item, index) => {
            item.prev = vehiclesData[index - 1];
            item.next = vehiclesData[index + 1];
            vm.vehicles.push(item);
          });

          VehicleService.setVehiclesCache(vm.vehicles);
          setVehicleNavigation();
          vm.loadingVehicles = false;
        },
        function () {
          vm.loadingVehicles = false;
        }
      );
    }

    function setVehicleNavigation() {
      vm.vehicleSelected = { ...vm.item };

      const vehicleFound = vm.vehicles.find((v) => v.id === vm.item.id);

      if (vehicleFound) {
        vm.vehicleSelected.prev = vehicleFound.prev;
        vm.vehicleSelected.next = vehicleFound.next;
      }
    }

    function selectVehicle(id) {
      goToOtherVehicle(id);
    }

    function goToOtherVehicle(id) {
      if (!id || vm.loadingOtherVehicle) {
        return;
      }

      vm.loadingOtherVehicle = true;

      VehicleService.getVehicle(id, vm.defaultLanguage).then(
        function (vehicle) {
          vm.item = vehicle;
          setItemOptions(vehicle);
          setVehicleNavigation();
          vm.loadingOtherVehicle = false;
        },
        function () {
          vm.loadingOtherVehicle = false;
        }
      );
    }
  }
})();
